module.exports = __webpack_public_path__ + "static/media/homeshowlogos-04.dd138dfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeshowlogos-04.jpg
// module id = 378
// module chunks = 0